import { render, staticRenderFns } from "./GraficosVendas.vue?vue&type=template&id=689ce61d"
import script from "./GraficosVendas.vue?vue&type=script&lang=js"
export * from "./GraficosVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports